class AppGridSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSlider();
    this.bindShopifyEvents();
  }

  initSlider() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library is not loaded. Please include Swiper JS.');
      return;
    }

    // Destroy existing instance if re-initializing
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this, {
      slidesPerView: 1.4,
      spaceBetween: 16,
      grabCursor: true,
      freeMode: false,
      breakpoints: {
        // Mobile Landscape / Small Tablet
        576: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },

      }
    });
  }

  bindShopifyEvents() {
    // Listen for Shopify Customizer changes to re-init Swiper dynamically
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        if (e.target.contains(this)) {
          this.initSlider();
        }
      });

      document.addEventListener('shopify:block:select', (e) => {
        if (this.contains(e.target) && this.swiper) {
          const slideIndex = Array.from(e.target.parentElement.children).indexOf(e.target);
          if (slideIndex !== -1) {
            this.swiper.slideTo(slideIndex);
          }
        }
      });
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

// Define Custom Element if not already registered
if (!customElements.get('app-grid-slider')) {
  customElements.define('app-grid-slider', AppGridSlider);
}